export default __webpack_public_path__ + "static/media/1546.feaa2d23.png";